/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1AssociatedcompanyId200,
  DeleteApiV1AssociatedcompanyId401,
  DeleteApiV1AssociatedcompanyId404,
  DeleteApiV1AssociatedcompanyId500,
  DeleteApiV1AssociatedcompanyIdMutationResponse,
  DeleteApiV1AssociatedcompanyIdPathParams,
} from "../../types/associatedCompanyController/DeleteApiV1AssociatedcompanyId.ts";
import { associatedCompanyInactivationViewModelSchema } from "../associatedCompanyInactivationViewModelSchema.ts";

export const deleteApiV1AssociatedcompanyIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1AssociatedcompanyIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1AssociatedcompanyId200Schema = z.lazy(
  () => associatedCompanyInactivationViewModelSchema,
) as unknown as ToZod<DeleteApiV1AssociatedcompanyId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1AssociatedcompanyId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1AssociatedcompanyId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1AssociatedcompanyId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1AssociatedcompanyId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1AssociatedcompanyId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1AssociatedcompanyId500>;

export const deleteApiV1AssociatedcompanyIdMutationResponseSchema = z.lazy(
  () => deleteApiV1AssociatedcompanyId200Schema,
) as unknown as ToZod<DeleteApiV1AssociatedcompanyIdMutationResponse>;
